import { useDispatch } from 'react-redux';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalHeader, ModalFooter } from 'ui/modal';
import { Body2 } from 'ui/theme';
import { PUBLISH_CAMPAIGN_MODAL } from '../../../constants';
import { closeModal } from '../../../ducks';
import { StyledWarningBanner } from './PublishCampaignModal.styles';

export const PUBLISH_CAMPAIGN_BUTTON_TEST_ID = 'publish-campaign-button';
export const DISCARD_CHANGES_BUTTON_TEST_ID = 'discard-changes-button';

type PublishCampaignModalProps = {
  /** Callback when on publish is triggered */
  onPublish: () => void;
  /** Callback when on cancel is triggered */
  onCancel: () => void;
  /** Whether the modal is open */
  isOpen: boolean;
};

export const PublishCampaignModal = ({
  onPublish,
  onCancel,
  isOpen,
}: PublishCampaignModalProps) => {
  /* Change Handlers */
  const dispatch = useDispatch();
  const handleCloseModal = () => dispatch(closeModal(PUBLISH_CAMPAIGN_MODAL));

  const handleCancel = () => {
    onCancel();
    handleCloseModal();
  };

  const handlePublish = () => {
    onPublish();
    handleCloseModal();
  };

  return (
    <Modal
      id={PUBLISH_CAMPAIGN_MODAL}
      isModalOpen={isOpen}
      onClose={handleCancel}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Update campaign?</ModalHeader>
      <ModalBody>
        <StyledWarningBanner Icon={false}>
          Your changes will be published immediately!
        </StyledWarningBanner>
        <Body2>
          Since this campaign is part of a published journey, users will start receiving the new
          version of this campaign as soon as you save.
        </Body2>
      </ModalBody>
      <ModalFooter hasCancel={false}>
        <Button
          data-test={DISCARD_CHANGES_BUTTON_TEST_ID}
          autoFocus
          onClick={handleCancel}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          Discard changes
        </Button>
        <Button
          data-test={PUBLISH_CAMPAIGN_BUTTON_TEST_ID}
          autoFocus
          onClick={handlePublish}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          Publish changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
